// src/components/sections/EtTestimonials.jsx
import { motion } from "framer-motion";
import { StarIcon } from "@heroicons/react/24/solid";
import { testimonials } from "@/data/testimonialData";

export default function EtTestimonials() {
  // First Created - 15 Aug 2025
  // Author - Atul Pandey
  // Updated - 16 Oct 2025 - Added headshots, refined headline and text tone

  return (
    <section
      id="success"
      className="py-20 bg-black text-white relative overflow-hidden"
    >
      

      {/* Content */}

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center font-poppins">
        {/* Section Heading */}
        <motion.h2
          className="text-3xl md:text-4xl font-bold mb-6 text-orange-600"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Voices of Transformation
        </motion.h2>

        <motion.p
          className="text-gray-300 max-w-2xl mx-auto mb-12"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          Real journeys. Real leaders. Real growth.
        </motion.p>

        {/* Testimonials Grid */}
        <div className="grid gap-10 md:grid-cols-3">
          {testimonials.map((t, index) => (
            <motion.div
              key={t.name}
              // className="p-6 bg-white/5 rounded-xl shadow-lg border border-white/10 flex flex-col justify-between"
              className="relative p-6 rounded-xl shadow-lg border border-white/10 flex flex-col justify-between overflow-hidden"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2, duration: 0.7 }}
            >
              {/* Background gradient animation */}
              <div className="absolute inset-0 bg-gradient-to-b from-black via-orange-800/40 to-black animate-[pulse_12s_ease-in-out_infinite]" />

              <div className="relative z-10">
                <div className="flex flex-col items-center mb-6">
                  {/* Headshot */}
                  <img
                    src={t.image}
                    alt={t.name}
                    className="h-16 w-16 rounded-full object-cover mb-4 border-2 border-orange-500"
                  />

                  {/* Stars */}
                  <div className="flex justify-center mb-3">
                    {[...Array(5)].map((_, i) => (
                      <StarIcon key={i} className="h-4 w-4 text-orange-500" />
                    ))}
                  </div>
                </div>

                <p className="text-gray-200 italic font-extralight mb-6 text-sm md:text-base leading-relaxed">
                  “{t.quote}”
                </p>

                <div>
                  <p className="font-semibold text-white">{t.name}</p>
                  {/* <p className="font-semibold text-orange-600">{t.name}</p> */}
                  <p className="text-gray-400 text-sm">{t.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}